module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/timesheet/Layout.ejs -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2> Timesheets </h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h3 class="timesheet-header">\n                        Week of:\n                        <a class="fa fa-angle-left m-l-md m-r-sm" href="#timesheet/'+
((__t=( prevWeek ))==null?'':_.escape(__t))+
'"></a>\n                        <span class="date-box">'+
((__t=( week ))==null?'':_.escape(__t))+
'</span>\n                        <a class="fa fa-angle-right m-l-sm" href="#timesheet/'+
((__t=( nextWeek ))==null?'':_.escape(__t))+
'"></a>\n                    </h3>\n                </div>\n\n                <div class="ibox-content js-content">\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/timesheet/Layout.ejs
// module id = 1026
// module chunks = 1